document.addEventListener("DOMContentLoaded", code);

if ( window.acf ) {
    window.acf.addAction('render_block_preview/type=map', code);
}

function code() {
    // iframe embed requires no JS initialisation
}
